import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Badge } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { deleteVehicleData, getVehicleList } from "../../redux/actions/VehicleActions";
import RoundedPagination from "../../Components/Paginate";
import FormInput from "../../Components/FormInput";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from '../../util/generalUtills'
import { deleteUserData, getUserList, logoutUserDevice, updateUserData } from "../../redux/actions/UserActions";
import Preloader from "../../Components/Preloader";
import classNames from "classnames";
import ExportToExcel from "../../Components/ExportToExcel";
import Status from "../../enums/Status";



const Dashboard = () => {
  const { t } = useTranslation();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    AuthReducer: { auth, errors, loading },
    userReducer: {
      userLists,
      userPermissions,
      loadingUsers,
      errorsUsers,
      changedUserStatus,
      userCount,
      changeUserStatus,
    },
  } = useSelector((state) => state);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(10);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;

  // useEffect(() => {
  //   dispatch(getVehicleList(auth?.accessToken, paginate, page, search, sort));
  // }, [auth, paginate, page, search, sort]);

  const fetchUserList = useCallback(() => {
    if (auth?.accessToken) {
      dispatch(getUserList(auth?.accessToken, paginate, page, search, sort ,"inactive", ));
    }
  }, [auth?.accessToken, paginate, page, search, sort, dispatch,]);

  useDebounce(fetchUserList, 500, [auth, paginate, page, search, sort]);


  useEffect(() => {
    if (errors) {
      if (errors?.status == 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }

  }, [errors])


  const handlePaginateChange = (e) => {
    const value = e.target.value === "All" ? userCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1); // Reset to the first page whenever the paginate value changes
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleDeleteRequest = (id) => {
    swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, delete it!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(deleteUserData(auth?.accessToken, id))
        }
      });
  };
const handleStatusChangeRequest = (item, newStatus) => {
    swal.fire({
      title: "Are you sure?",
      text: `Do you want to change the status to ${newStatus}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
             dispatch(updateUserData(auth?.accessToken, {
         name: item?.name,
          email: item?.email,
          password: item?.password,
          mobile:item?.mobile,
          username:item?.username,
          stateCode:item?.state?.id,
          cityCode:item?.city?.id,    
          reportingId:item?.reportingUser?.id,      
          roleId: item?.role?.roleName,
          status:newStatus
              
             }, item?.id));
       
      
      }
    });
  };




  useEffect(() => {
    if (changeUserStatus?.message) {
      swal.fire({
        show: true,
        title: "Deleted!",
        text: changeUserStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_STATUS' });
      dispatch(getUserList(auth?.accessToken, paginate, page, search, sort,"inactive"));
    }

  }, [changeUserStatus])

  const userLogout = (itemDetails) => {
    swal.fire({
      title: "Are you sure?",
      text: `You want to logout from ${itemDetails?.brand} ${itemDetails?.model} ${itemDetails?.deviceType}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, logout !",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logoutUserDevice(auth?.accessToken, itemDetails?.id));
      }
    });

  };

  useEffect(() => {
    if (changedUserStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedUserStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch(getUserList(auth?.accessToken, paginate, page, search, sort,"inactive"));
      dispatch({ type: 'RESET_DELETE_USER_STATUS' });
    }
  }, [changedUserStatus, dispatch, navigate]);


  const tableRef = useRef();
  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Inactive User"), path: "/Users", active: true },
        ]}
        title={t("Inactive User")}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                  <Col lg={3}>
                    {(userPermissions?.filter) && (
                      <>
                        <div className="d-flex align-items-center">
                          <input
                            type="search"
                            placeholder="Search..."
                            className="form-control ms-1"
                            autoComplete="off"
                            value={search}
                            onChange={handleSearchChange}
                          />
                        </div>
                      </>
                    )}
                  </Col>
                  <Col lg={9}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                       
                        {(userPermissions?.print) && (
                          <>
                            <Button variant="dark">
                              <i className="mdi mdi-printer me-1"></i>Print
                            </Button>
                          </>
                        )}
                        {(userPermissions?.excel) && (
                          <>
                            <Button variant="info">
                              <i className="mdi mdi-file-excel me-1"></i>Excel
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div style={{ overflowY: 'auto', maxHeight: '500px', border: "1px solid #dee2e6" }}>
                <Table ref={tableRef} className="mb-0 table-bordered"
                  size="sm"
                  striped
                  responsive
                  id="table-to-print"
                  style={{ width: "100%", tableLayout: "auto" }}>
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th>SR No.</th>
                      <th>Name</th>
                      <th>Contact</th>
                      <th>User Type</th>
                      <th>City</th>
                      <th>Username</th>
                      <th>Reporting Authority</th>
                      <th>Device</th>
                      <th>Status</th>
                      <th>Registered On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userLists.length === 0 ? (
                      <tr>
                        <td colSpan="10">No data found</td>
                      </tr>
                    ) : (<>
                      {userLists?.map?.((item, index) => {
                        return (
                          <tr key={item.id}>
                            <th scope="row">{index + 1 + (page - 1) * paginate}</th>

                            <td>{item?.name}</td>
                            <td>{item?.mobile}</td>
                            <td>{item?.role?.roleName}</td>
                            <td>{item?.city?.cityName}</td>
                            <td>{item?.username}</td>
                            <td>{item?.reportingUser?.name}</td>
                            <td>Version : {item?.appVersion}<br />{item?.brand} {item?.model} ({item?.mobileVersion})</td>
                              <td>{item?.status === Status.ACTIVE? <Badge className={"bg-success"}>{item?.status}</Badge> : <><Badge className={"bg-danger"}>{item?.status}</Badge></>}</td>
                            <td>{getDisplayDateTimeFormat(item?.createdAt)}</td>
                            <td>
                              {(userPermissions?.edit) && (

                                    <>
                                {item?.status === Status.ACTIVE && (
                                    <>
                                      <Link to="#" className="action-icon text-success" onClick={() => handleStatusChangeRequest(item, Status.INACTIVE)}>
                                        {" "}
                                        <i className="mdi mdi-eye"></i>
                                      </Link>
                                    </>
                                  )}
                                  {item?.status === Status.INACTIVE && (
                                    <>
                                      <Link to="#" className="action-icon text-warning" onClick={() => handleStatusChangeRequest(item,Status.ACTIVE)}>
                                        {" "}
                                        <i className="mdi mdi-eye-off"></i>
                                      </Link>
                                    </>
                                  )}



                                  <Link to={`/Update-User/${item?.id}`} className="action-icon text-info">
                                    <i className="mdi mdi-square-edit-outline"></i>
                                  </Link>
                                </>
                              )}

                              {item?.imei != null && (<>
                                <Link onClick={() => userLogout(item)} className="action-icon text-warning">
                                  <i className="mdi mdi-logout"></i>
                                </Link>
                              </>)}

                              {(userPermissions?.delete) && (
                                <>
                                  <Link to="#" className="action-icon text-danger" onClick={() => handleDeleteRequest(item?.id)} >
                                    {" "}
                                    <i className="mdi mdi-delete"></i>
                                  </Link>
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}</>
                    )}
                  </tbody>
                </Table>
              </div>
              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(userCount / paginate)}</strong> </span>
                <RoundedPagination
                  currentPage={page}
                  totalPages={Math.ceil(userCount / paginate)}
                  onPageChange={(pageNumber) => setPage(pageNumber)}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingUsers && (<Preloader />)}
    </>
  );
};

export default Dashboard;
